
    import { defineComponent, PropType } from 'vue'
    import Column from 'primevue/column'
    import DataTable from 'primevue/datatable'
    import Dialog from 'primevue/dialog'
    import { iValues } from './TargetDefinition'
    import { filterDefault } from '@/helpers/commons/filterHelper'
    import { FilterOperator } from 'primevue/api'
    import targetDefinitionDetailDescriptor from './TargetDefinitionDetailDescriptor.json'
    import { formatDate } from '@/helpers/commons/localeHelper'

    export default defineComponent({
        name: 'add-kpi-dialog',
        components: {
            DataTable,
            Column,
            Dialog
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            kpi: {
                type: Array as PropType<iValues[]>,
                required: false
            },
            loadingKpi: {
                type: Boolean,
                default: false
            }
        },
        emits: ['close', 'add'],
        data() {
            return {
                selectedKpi: [] as iValues[],
                targetDefinitionDetailDescriptor: targetDefinitionDetailDescriptor,
                filters: {
                    global: [filterDefault],
                    kpiName: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    },
                    kpiCategory: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    },
                    domainCode: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    },
                    kpiDate: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    },
                    kpiAuthor: {
                        operator: FilterOperator.AND,
                        constraints: [filterDefault]
                    }
                } as Object,
                formatDate: formatDate
            }
        },
        methods: {
            addKpi() {
                this.$emit('add', this.selectedKpi)
                this.selectedKpi = []
            },
            closeKpiDialog() {
                this.$emit('close')
            }
        }
    })
